import styles from "./RatingCard.module.scss";
import goldIcon from "./icons/gold.png";
import silverIcon from "./icons/silver.png";
import bronzeIcon from "./icons/bronze.png";
import { FC, ReactNode } from "react";
import { Avatar } from "../Avatar/Avatar";

interface IRatingCardProps {
    rank: number,    
    name: string,
    score: number;
    avatar?: string,
    my?: boolean,
}

const backgroundStyles: Record<number, string | undefined> = {
    1: styles.goldBackground,
    2: styles.silverBackground,
    3: styles.bronzeBackground,
};

const rankIcons: Record<number, ReactNode | undefined> = {
    1: <img src={goldIcon} alt="Gold" className={styles.rankIcon} />,
    2: <img src={silverIcon} alt="Silver" className={styles.rankIcon} />,
    3: <img src={bronzeIcon} alt="Bronze" className={styles.rankIcon} />,
};

export const RatingCard: FC<IRatingCardProps> = ({ rank, avatar, name, score, my }) => {    
    const getBackgroundStyle = () => {
        const backgroundStyle = backgroundStyles[rank] || (my ? styles.myBackground : styles.defaultBackground);
        const myStyle = my ? styles.my : '';
        return `${backgroundStyle} ${myStyle}`;
    }

    return (
        <div
            className={`${styles.card} ${ getBackgroundStyle() }`}
        >
            <div className={styles.content}>
                <Avatar name={ name } url={ avatar } />
                
                <div className={styles.info}>                
                    <div className={styles.name}>{name.substring(0, 20)}</div>

                    <div className={styles.score}>{score.toLocaleString("ru-RU")}</div>
                </div>
            </div>

            <div className={styles.rank}>
                {rankIcons[rank] || <span className={styles.rankText}>{rank}</span>}
            </div>
        </div>
    );
};